import React from 'react';
import AdminDashboardHomeComponent from './admin-dashboard-home.component';

export default function AdminDashboardHome() {
    return <AdminDashboardHomeComponent />;
}
